(() => {
  class HomeCategorySwiper extends HTMLElement {
    connectedCallback() {
      const sectionId = this.dataset.sectionId || "";
      const blockIds = (this.dataset.blockIds || "").split(",").filter(Boolean);
      const isAutoplay = this.dataset.autoplay === "true";
      const autoplayDelay = parseInt(this.dataset.autoplayDelay || "0", 10) || 0;
      const productSwipers = [];
      const init = () => {
        const tabSwiperEl = this.querySelector(`#home-category-swiper__tabs-swiper_${sectionId}`);
        const tabSwiper = new Swiper(tabSwiperEl, {
          slidesPerView: "auto",
          freeMode: true,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          breakpoints: { 590: { slidesPerView: 5 } }
        });
        const initProductSwiper = (blockId) => {
          const productSwiperEl = this.querySelector(`#home-category-swiper__swiper_${blockId}`);
          const controllerWrapper = productSwiperEl.parentElement.querySelector(".controller-wrapper");
          setTimeout(() => {
            const productSwiper = new Swiper(productSwiperEl, {
              autoplay: isAutoplay
                ? { delay: autoplayDelay, stopOnLastSlide: false, disableOnInteraction: false }
                : false,
              // autoplay: true,
              slidesPerView: 4,
              navigation: {
                nextEl: controllerWrapper.querySelector(".btn-swiper-right"),
                prevEl: controllerWrapper.querySelector(".btn-swiper-left")
              },
              pagination: {
                el: productSwiperEl.querySelector(".swiper-pagination"),
                clickable: true
              },
              observer: true,
              resizeObserver: true,
              // simulateTouch: true, // 显式声明
              // touchStartPreventDefault: false, //修复 iOS 滑动冲突
              observeParents: true,
              breakpoints: {
                1000: { slidesPerView: 3 },
                590: { slidesPerView: 2, spaceBetween: 13 }
              },
              on: {
                autoplay: () => {
                  const tabsSlides = this.querySelectorAll(".home-category-swiper__tabs .swiper-slide");
                  const index = productSwiper.activeIndex;
                  if (index === 0) {
                    const activeIndex = Array.from(tabsSlides).findIndex((s) => s.classList.contains("active"));
                    const nextTabIndex = (activeIndex + 1) % tabsSlides.length;
                    const nextProductSwiper = productSwipers[nextTabIndex];
                    productSwiper.autoplay.stop();
                    tabSwiper.slideTo(nextTabIndex);
                    tabsSlides[nextTabIndex].dispatchEvent(new Event("click", { bubbles: true }));
                    if (nextProductSwiper) nextProductSwiper.autoplay.start();
                  }
                }
              }
            });
            if (productSwipers.length !== 0 && isAutoplay) {
              productSwiper.autoplay.stop();
            }
            productSwipers.push(productSwiper);

            const slidesPerViewForWidth = () => {
              const width = window.innerWidth;
              if (width <= 590) return 2;
              if (width <= 1000) return 3;
              return 4;
            };
            const syncPagination = () => {
              const paginationEl = productSwiperEl.querySelector(".swiper-pagination");
              const count = productSwiperEl.querySelectorAll(".swiper-slide").length;
              const hide = count <= slidesPerViewForWidth();
              productSwiperEl.parentElement.classList.toggle("is-static", hide);
              if (paginationEl) paginationEl.hidden = hide;
              productSwiper.allowTouchMove = !hide;
            };
            productSwiper.on("breakpoint", syncPagination);
            productSwiper.on("resize", syncPagination);
            window.addEventListener("resize", syncPagination);
            syncPagination();
          }, 100);
        };
        blockIds.forEach((bid) => initProductSwiper(bid));
        const tabsSlides = Array.from(this.querySelectorAll(".home-category-swiper__tabs .swiper-slide"));
        tabsSlides.forEach((slide, i) => {
          slide.addEventListener("click", () => {
            const pastActivedTabIndex = tabsSlides.findIndex((s) => s.classList.contains("active"));
            if (pastActivedTabIndex !== -1) {
              if (isAutoplay) productSwipers[pastActivedTabIndex].autoplay.stop();
              productSwipers[pastActivedTabIndex].slideTo(0);
            }
            slide.classList.add("active");
            tabsSlides.forEach((s, idx) => {
              if (idx !== i) s.classList.remove("active");
            });
            const containers = Array.from(this.querySelectorAll(".home-category-swiper__product-container"));
            containers.forEach((c, idx) => {
              if (idx === i) c.classList.add("active");
              else c.classList.remove("active");
            });
            if (isAutoplay) productSwipers[i].autoplay.start();
          });
        });
        if (isAutoplay) {
          const containers = Array.from(this.querySelectorAll(".home-category-swiper__products .swiper-container"));
          const enterEvent = () => {
            const currentTabIndex = tabsSlides.findIndex((s) => s.classList.contains("active"));
            if (currentTabIndex !== -1) productSwipers[currentTabIndex].autoplay.stop();
          };
          const leaveEvent = () => {
            const currentTabIndex = tabsSlides.findIndex((s) => s.classList.contains("active"));
            if (currentTabIndex !== -1) productSwipers[currentTabIndex].autoplay.start();
          };
          containers.forEach((el) => {
            el.addEventListener("mouseenter", enterEvent);
            el.addEventListener("mouseleave", leaveEvent);
          });
        }
        const icons = this.querySelectorAll(".home-category-swiper__tab-item .icon");
        const applyRandomSkewY = () => {
          icons.forEach((icon) => {
            const randomSkewY = Math.random() * 20 - 10;
            icon.style.setProperty("--random-skewY", `${randomSkewY}deg`);
          });
        };
        applyRandomSkewY();
        this._skewInterval = setInterval(applyRandomSkewY, 300);
      };
      const waitForSwiper = () => {
        if (typeof Swiper !== "undefined") init();
        else setTimeout(waitForSwiper, 50);
      };
      waitForSwiper();
    }
    disconnectedCallback() {
      if (this._skewInterval) clearInterval(this._skewInterval);
    }
  }
  customElements.define("home-category-swiper", HomeCategorySwiper);
})();
